import { combineReducers } from "redux";
import commonOnePlatFormReducer from "@frameworks/web/redux/reducers/common/commonReducer";
import { MARKET_MAP_DATA, } from "@frameworks/web/redux/interfaces/Reports/iAccountOverview";
const MarketMapAccReducer = (state, action) => {
    switch (action.type) {
        case MARKET_MAP_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.mapDetails });
        default:
            return Object.assign({}, state);
    }
};
export default combineReducers({
    reducersData: MarketMapAccReducer,
    commonData: commonOnePlatFormReducer,
});
